import {
  PortalProps as MantinePortalProps,
  Portal as MantinePortal,
} from '@mantine/core';

export type PortalProps = MantinePortalProps;

export const Portal = MantinePortal;

Portal.displayName = 'Portal';
